import RequestService from './request';
import type {
    SboxFeaturedResponse,
    SboxFiltersResponse,
    SboxPackageDetailResponse,
    SboxPackageFindResponse,
    SboxPackageSearchParams,
    SboxPartnersResponse,
} from '~/api/models/SboxPackage';

const buildSearchPayload = (params: SboxPackageSearchParams): Record<string, unknown> => {
    const payload: Record<string, unknown> = {
        type: params.type,
    };

    if (params.q) {
        payload.q = params.q;
    }
    if (params.sort) {
        payload.sort = params.sort;
    }
    if (params.org) {
        payload.org = params.org;
    }
    if (typeof params.page === 'number') {
        payload.page = params.page;
    }
    if (typeof params.perPage === 'number') {
        payload.per_page = params.perPage;
    }
    if (params.tags && params.tags.length > 0) {
        payload.tags = params.tags;
    }
    if (params.properties && params.properties.length > 0) {
        payload.properties = params.properties;
    }
    if (params.facets) {
        const tokens: string[] = [];
        for (const [key, values] of Object.entries(params.facets)) {
            if (!Array.isArray(values)) {
                continue;
            }
            for (const value of values) {
                if (typeof value === 'string' && value !== '') {
                    tokens.push(`${key}:${value}`);
                }
            }
        }
        if (tokens.length > 0) {
            payload.facets = tokens;
        }
    }

    return payload;
};

class SboxPackagesService {
    find(params: SboxPackageSearchParams): Promise<SboxPackageFindResponse> {
        return RequestService.get('/servers/:server/sbox/packages/find', buildSearchPayload(params));
    }

    show(fullIdent: string): Promise<SboxPackageDetailResponse> {
        return RequestService.get(`/servers/:server/sbox/packages/${fullIdent}`);
    }

    filters(): Promise<SboxFiltersResponse> {
        return RequestService.get('/servers/:server/sbox/packages/filters');
    }

    featured(): Promise<SboxFeaturedResponse> {
        return RequestService.get('/servers/:server/sbox/packages/featured');
    }

    partners(): Promise<SboxPartnersResponse> {
        return RequestService.get('/servers/:server/sbox/packages/partners');
    }
}

export default new SboxPackagesService();
